module.exports = __webpack_public_path__ + "img/undraw_color_palette_yamk.78fd7a96.svg";